<template>
  <div class="agree">
    <p class="ql-align-center">
      <strong style="background-color: transparent; color: black;">首信易支付隐私政策</strong>
    </p>
    <p>
      <br />
    </p>
    <p>
      <strong style="background-color: transparent; color: black;">概述和声明</strong>
    </p>
    <p>
      <span
        style="background-color: transparent; color: black;"
      >易智付科技（北京）有限公司（以下或称“首信易支付”）尊重并保护用户隐私，将按照本隐私权政策（以下简称“本政策”）收集、使用及共享您信息。本政策包含了首信易支付收集、存储、保护、使用和共享您的信息的条款，我们建议您完整地阅读本政策，以帮助您了解维护自己隐私权的方式。为了使您充分理解本政策的内容，本政策中与您的权益存在或可能存在重大关系的条款，我们已采用粗体字进行标注提示您注意。</span>
      <strong
        style="background-color: transparent; color: black;"
      >当您同意注册首信易支付账户或使用首信易支付提供的任一服务时，即表示您已同意我们按照本政策来合法使用和保护您的信息。</strong>
    </p>
    <p>
      <span style="background-color: transparent; color: black;">本政策将帮助您了解以下内容：</span>
    </p>
    <p>
      <span style="background-color: transparent; color: black;">1. 我们如何收集和使用您的个人信息</span>
    </p>
    <p>
      <span style="background-color: transparent; color: black;">2. 我们如何使用 Cookie和同类技术</span>
    </p>
    <p>
      <span style="background-color: transparent; color: black;">3. 我们如何共享、转让、公开披露您的个人信息</span>
    </p>
    <p>
      <span style="background-color: transparent; color: black;">4. 我们如何保护您的个人信息</span>
    </p>
    <p>
      <span style="background-color: transparent; color: black;">5. 您的权利</span>
    </p>
    <p>
      <span style="background-color: transparent; color: black;">6. 我们如何处理儿童的个人信息</span>
    </p>
    <p>
      <span style="background-color: transparent; color: black;">7. 您的个人信息如何在全球范围转移</span>
    </p>
    <p>
      <span style="background-color: transparent; color: black;">8. 本政策如何更新</span>
    </p>
    <p>
      <span style="background-color: transparent; color: black;">9、如何联系我们</span>
    </p>
    <p>
      <strong style="background-color: transparent; color: black;">一、我们如何收集和使用您的个人信息</strong>
    </p>
    <p>
      <span
        style="background-color: transparent; color: black;"
      >个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。首信易支付仅会出于本政策所述的以下目的，收集和使用您的个人信息：</span>
    </p>
    <p>
      <strong style="color: black;">（一）依据法律法规及监管规定履行反洗钱义务及进行实名制管理</strong>
      <span style="color: black;">&nbsp;</span>
    </p>
    <p>
      <span style="color: black;">1. 在您注册首信易支付账户或使用首信易支付服务时，您需提供您的</span>
      <strong style="color: black;">有效身份证件信息、联系方式、地址、职业</strong>
      <span
        style="color: black;"
      >。这些信息可能由首信易支付直接向您收集，也可能由与我们合作的您所注册的应用程序的经营者提供给首信易支付，您授权并同意上述经营者向首信易支付提供前述信息，如您不提供前述信息，可能无法注册首信易支付账户或无法使用首信易支付服务。根据相关法律法规的规定，您需通过身份基本信息多重交叉验证后方可使用我们的部分服务（例如：大额支付），如果您需使用此类服务，则需提供更多信息（例如：</span>
      <strong style="color: black;">绑定银行卡信息</strong>
      <span
        style="color: black;"
      >）以完成身份基本信息多重交叉验证。如您不提供前述信息，可能无法使用需要通过多重交叉验证后方可使用的部分服务，但不影响您使用我们提供的其他服务。同时，为了验证您提供信息的准确性和完整性，我们会与合法留存您的前述信息的国家机关、金融机构、企事业单位进行核对；&nbsp;</span>
    </p>
    <p>
      <span style="color: black;">2. 我们需根据《支付机构反洗钱和反恐怖融资管理办法》等反洗钱相关法律法规及监管要求，提示您适时提供</span>
      <strong style="color: black;">有效身份证件的彩色影印件或照片</strong>
      <span
        style="color: black;"
      >以供我们核对并留存；您授权并同意您所注册的应用程序的经营者将上述文件提供给首信易支付，如您不提供前述彩色影印件、照片或不同意我们留存，可能无法使用与监管要求相关的部分服务。&nbsp;</span>
    </p>
    <p>
      <strong style="color: black;">（二）支付</strong>
      <span style="color: black;">&nbsp;</span>
    </p>
    <p>
      <span style="color: black;">1. 为了向您提供支付服务，同时向您提供账单查询管理功能，我们需要记录您的</span>
      <strong style="color: black;">支付账户余额信息以及交易信息</strong>
      <span style="color: black;">。如您不同意我们记录前述信息，将无法使用支付服务；&nbsp;</span>
    </p>
    <p>
      <span style="color: black;">2. 为了您能使用快捷支付服务，实现使用银行卡对首信易支付账户余额的充值、提现以及基于银行卡的消费、转账、红包等功能，您需提供您的</span>
      <strong style="color: black;">银行卡卡号、姓名、身份证号码、银行预留手机号</strong>
      <span style="color: black;">。我们会将前述信息与发卡银行进行验证。如您不提供前述信息，可能无法使用快捷支付服务；&nbsp;</span>
    </p>
    <p>
      <span style="color: black;">3. 为了准确执行您的支付指令，在您向他人的首信易支付账户转账时，您需按照支付页面提示输入</span>
      <strong style="color: black;">收款人账户、收款人姓名、转账金额</strong>
      <span style="color: black;">；在您转账至他人银行卡时，您需输入&nbsp;</span>
      <strong style="color: black;">收款人姓名、卡号、开户银行</strong>
      <span style="color: black;">；如您不提供前述信息，转账可能无法进行；</span>
    </p>
    <p>
      <span
        style="color: black;"
      >4. 为了保障您的账户和资金安全，在您进行一些重要操作时（例如：找回密码、挂失账户、冻结交易资金、开具账户和资金相关凭证）时，我们需要验证您的身份，为此您可能需向我们提供一些可识别您身份的证明资料（例如：</span>
      <strong style="color: black;">身份证件影印件、手持身份证照片、交易凭证</strong>
      <span
        style="color: black;"
      >等），您可根据相关页面或客服人员的提示提供您的证明资料；如您不同意提供前述信息，您将无法完成特定操作，但不影响您使用我们提供的其他服务。&nbsp;</span>
    </p>
    <p>
      <strong style="color: black;">（三）信息查询</strong>
    </p>
    <p>
      <span style="background-color: transparent; color: rgb(51, 51, 51);">按照法律法规及监管规定，同时为了向您提供</span>
      <strong style="background-color: transparent; color: rgb(51, 51, 51);">信息查询服务</strong>
      <span
        style="background-color: transparent; color: rgb(51, 51, 51);"
      >，在您通过我们或者我们合作的第三方商家进行交易时，我们需要对您进行交易时的交易信息进行记录和管理，我们需要直接收集或者通过我们合作的第三方商家收集与您交易相关的信息（包括</span>
      <strong
        style="background-color: transparent; color: rgb(51, 51, 51);"
      >交易单号、交易双方名称、交易金额、交易时间、商品名称、付款方式、配送信息等</strong>
      <span style="background-color: transparent; color: rgb(51, 51, 51);">）。如您不同意对交易信息的记录，将无法完成交易。</span>
    </p>
    <p>
      <strong style="color: black;">（四）安全管理</strong>
      <span style="color: black;">&nbsp;</span>
    </p>
    <p>
      <span style="color: black;">为了保障向您提供的服务的安全稳定运行，预防交易和资金风险，我们需要记录您使用的首信易支付服务类别、方式及相关操作信息，例如：</span>
      <strong style="color: black;">MAC地址、IP地址、设备识别码、网络使用习惯以及其他与首信易支付服务相关的日志信息</strong>
      <span style="color: black;">。如您不同意我们记录前述信息，可能无法完成风控验证。&nbsp;</span>
    </p>
    <p>
      <strong style="color: black;">（五）根据相关法律法规及国家标准，在以下情形中，我们可能会依法收集并使用您的个人信息无需征得您的同意</strong>
      <span style="color: black;">&nbsp;</span>
      <strong style="color: black;">:</strong>
      <span style="color: black;">&nbsp;</span>
    </p>
    <p>
      <strong style="color: black;">1. 与国家安全、国防安全直接相关的；</strong>
      <span style="color: black;">&nbsp;</span>
    </p>
    <p>
      <strong style="color: black;">2. 与公共安全、公共卫生、重大公共利益直接相关的；</strong>
      <span style="color: black;">&nbsp;</span>
    </p>
    <p>
      <strong style="color: black;">3. 与犯罪侦查、起诉、审判和判决执行等直接相关的；</strong>
      <span style="color: black;">&nbsp;</span>
    </p>
    <p>
      <strong style="color: black;">4. 出于维护您或他人的生命、财产等重大合法权益但又很难得到您本人同意的；</strong>
      <span style="color: black;">&nbsp;</span>
    </p>
    <p>
      <strong style="color: black;">5. 所收集的个人信息是您自行向社会公众公开的；</strong>
      <span style="color: black;">&nbsp;</span>
    </p>
    <p>
      <strong style="color: black;">6. 从合法公开披露的信息中收集个人信息，例如：合法的新闻报道、政府信息公开等渠道；</strong>
      <span style="color: black;">&nbsp;</span>
    </p>
    <p>
      <strong style="color: black;">7. 根据您的要求签订和履行合同所必需的；</strong>
      <span style="color: black;">&nbsp;</span>
    </p>
    <p>
      <strong style="color: black;">8. 用于维护所提供的服务的安全稳定运行所必需的，例如：发现、处置服务的故障；</strong>
      <span style="color: black;">&nbsp;</span>
    </p>
    <p>
      <strong style="color: black;">9. 法律法规规定的其他情形。</strong>
      <span style="color: black;">&nbsp;</span>
    </p>
    <p>
      <strong style="color: black;">（六）其他</strong>
      <span style="color: black;">&nbsp;</span>
    </p>
    <p>
      <span style="background-color: transparent; color: black;">1. 当我们要将信息用于本政策未载明的其它用途时，会事先征求您的同意。</span>
    </p>
    <p>
      <span
        style="background-color: transparent; color: black;"
      >2. 当我们要将基于特定服务收集而来的信息用于其他服务时，会事先征求您的同意。</span>
    </p>
    <p>
      <strong style="background-color: transparent; color: black;">二、我们如何使用 Cookie 和同类技术</strong>
    </p>
    <p>
      <span
        style="background-color: transparent; color: black;"
      >首信易支付不会使用Cookie技术或同类技术存储您的任何信息，请您注意，</span>
      <strong
        style="background-color: transparent; color: black;"
      >您的交易相对方、您访问的第三方网站经营者、您使用的第三方服务提供者和由首信易支付处接受您的个人信息的第三方可能有自己的隐私权保护政策；当您查看第三方创建的网页或使用第三方开发的应用程序时，可能会发现该网页或应用程序放置的Cookie或像素标签。同样，这些第三方可能会放置他们自己的Cookie或像素标签，这些Cookie或标签不受我们的控制，而且它们的使用不受本政策的约束。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: black;"
      >我们会尽商业上的合理努力去要求这些主体对您的个人信息采取保护措施，但我们无法保证这些主体一定会按照我们的要求采取保护措施，亦不对这些主体的行为及后果承担任何责任。如果您发现这些第三方创建的网页或第三方开发的应用程序存在风险时，建议您终止相关操作以保护您的合法权益。</strong>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">三、我们如何共享、转让、公开披露您的个人信息</strong>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">（一）共享</strong>
    </p>
    <p class="ql-align-justify">
      <strong
        style="background-color: transparent; color: black;"
      >我们不会与首信易支付以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：</strong>
    </p>
    <ol>
      <li class="ql-align-justify">
        <strong style="background-color: transparent;">在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</strong>
      </li>
    </ol>
    <p class="ql-align-justify">
      <strong
        style="background-color: transparent; color: black;"
      >2. 我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。</strong>
    </p>
    <p class="ql-align-justify">
      <strong
        style="background-color: transparent; color: black;"
      >3. 与我们的关联公司共享：您的个人信息可能会与首信易支付的关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。</strong>
    </p>
    <p class="ql-align-justify">
      <strong
        style="background-color: transparent; color: black;"
      >我们的关联公司包括：易智付科技（北京）有限公司直接或间接控股的公司，及其参股或形成经营、协作联系的关联单位，包括但不限于北京金泉国际旅行社有限公司、北京易智付电子商务有限公司。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: black;"
      >4. 与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。</strong>
      <strong
        style="color: black;"
      >我们承诺对您的信息进行严格保密。除法律法规及监管部门另有规定外，我们仅在以下情形中与第三方共享您的信息，第三方包括我们的合作金融机构以及其他合作伙伴。如果为了向您提供服务而需要将您的信息共享至第三方，我们将评估该第三方收集信息的合法性、正当性、必要性。我们将要求第三方对您的信息采取保护措施，并且严格遵守相关法律法规与监管要求。另外，我们会按照法律法规及国家标准的要求以确认协议、具体场景下的文案确认、弹窗提示等形式征得您的同意，或确认第三方已经征得您的同意。&nbsp;</strong>
    </p>
    <p class="ql-align-justify">
      <strong
        style="background-color: transparent; color: black;"
      >对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协议，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。</strong>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">（二）转让</strong>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</strong>
    </p>
    <p class="ql-align-justify">
      <strong
        style="background-color: transparent; color: black;"
      >1． 在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</strong>
    </p>
    <p class="ql-align-justify">
      <strong
        style="background-color: transparent; color: black;"
      >2． 在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</strong>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">（三）公开披露</strong>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">我们仅会在以下情况下，公开披露您的个人信息：</strong>
    </p>
    <ol>
      <li class="ql-align-justify">
        <strong style="background-color: transparent;">获得您明确同意后；</strong>
      </li>
      <li class="ql-align-justify">
        <strong
          style="background-color: transparent;"
        >基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</strong>
      </li>
    </ol>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">四、我们如何保护您的个人信息</strong>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: black;"
      >（一）我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如，在您的浏览器与“服务”之间交换数据（如信用卡信息）时受 SSL 加密保护；我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</span>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: black;"
      >（二）我们已经取得了《银联卡支付信息安全合规证书》、《管理体系认证证书》PCI数据安全标准（</span>
      <span style="color: rgb(25, 25, 25);">Payment Card Industry Data Security Standard）</span>
      <span style="background-color: transparent; color: black;">等认证。</span>
    </p>
    <p class="ql-align-justify">
      <span style="background-color: transparent; color: black;">（三）我们的数据安全能力：</span>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: black;"
      >1． 首信易支付将会基于您使用我们的服务的必要以及在法律法规或监管规定的期限内保存您的信息。</span>
      <strong
        style="background-color: transparent; color: black;"
      >例如，我们将会按照《支付机构反洗钱和反恐怖融资管理办法》规定的期限保存您的身份资料、交易记录。超出法律法规或监管规定的期限后，我们会按照法律法规的要求对您的个人信息进行删除或者匿名化处理。</strong>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: black;"
      >2． 为了保障您的信息安全，我们会在现有技术水平下采取合理必要的措施来保护您的信息，采取物理防护、安全技术、管理制度等措施来降低丢失、误用、非授权访问、披露和更改的风险，包括但不限于数据加密传输、防火墙和加密存储、物理访问控制以及信息访问授权控制。为此我们设置了安全程序保护您的信息不会被未经授权的访问所窃取，所有的个人信息被加密储存并放置于经防火墙严格保护的内部系统。</span>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: black;"
      >3． 为了保障您的信息安全，我们建立了专门的管理制度、流程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。</span>
    </p>
    <p class="ql-align-justify">
      <strong
        style="background-color: transparent; color: black;"
      >4． 您在使用我们的服务时，请妥善保管好您的登录名及其密码，我们会通过您的登录名及其密码来识别您的身份。一旦您泄漏了登录名及其密码，您可能会丢失您的信息，并可能产生对您不利的法律后果。如您发现登录名及其密码因任何原因已经或将受到泄漏时，请您立即和我们取得联系，以便我们及时采取相应措施以防止或减少相关损失，因您未及时联系我们致使您遭受损失的，由您自行负责。</strong>
    </p>
    <p class="ql-align-justify">
      <strong
        style="background-color: transparent; color: black;"
      >5． 若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并及时以推送通知、电话、公告等形式告知您上述安全事件，如采用上述方式仍无法联系您时，我们将通过首信易支付官方网站发布相关警示信息，请您保持对首信易支付官方网站的密切关注。</strong>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: black;"
      >6． 如您终止使用首信易支付服务，我们将会停止收集和使用您的信息，法律法规或监管部门另有规定的除外。如我们的产品或者服务停止运营，我们也将及时停止收集和使用您的信息，同时，将停止运营的通知在首信易支付官方网站以公告的形式通知您，并将对保存的您的个人信息进行删除或匿名化处理。</span>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: black;"
      >（四）我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</span>
    </p>
    <p class="ql-align-justify">
      <strong
        style="background-color: transparent; color: black;"
      >（五）互联网并非绝对安全的环境，而且电子邮件、即时通讯等交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。请使用复杂密码，协助我们保证您的账号安全。</strong>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: black;"
      >（六）互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</span>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: black;"
      >（七）在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。</span>
    </p>
    <p class="ql-align-justify">
      <span style="background-color: transparent; color: black;">同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</span>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">五、您的权利</strong>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: black;"
      >按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法我们保障您对自己的个人信息行使以下权利：</span>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">（一）访问您的个人信息</strong>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: black;"
      >您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：</span>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: black;"
      >账户信息——如果您希望访问或编辑您的账户中的个人资料信息和支付信息、更改您的密码、添加安全信息或关闭您的账户等，您可以通过访问您所注册的应用程序中的钱包或类似功能执行此类操作。</span>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: black;"
      >如果您无法通过上述链接访问这些个人信息，您可以随时发送电子邮件至cs@payeasenet.com。我们将在30天内回复您的访问请求。</span>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">（二）个人信息主体注销账户</strong>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: black;"
      >您随时可注销此前注册的账户，在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，法律法规另有规定的除外。</span>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">（三）响应您的上述请求</strong>
    </p>
    <p class="ql-align-justify">
      <strong
        style="background-color: transparent; color: black;"
      >为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</strong>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: black;"
      >我们将在三十天内做出答复。如您不满意，还可以通过本协议第九条约定的诉讼方式解决。</span>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: black;"
      >对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</span>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">在以下情形中，按照法律法规要求，我们将无法响应您的请求：</strong>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">1．与国家安全、国防安全直接相关的；</strong>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">2．与公共安全、公共卫生、重大公共利益直接相关的；</strong>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">3．与犯罪侦查、起诉、审判和判决执行等直接相关的；</strong>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">4．有充分证据表明您存在主观恶意或滥用权利的；</strong>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">5．响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</strong>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">6．涉及商业秘密的。</strong>
    </p>
    <p class="ql-align-justify">
      <br />
    </p>
    <p>
      <strong
        style="background-color: transparent; color: black;"
      >（四）如您发现我们收集、使用您个人信息的行为，违反了法律、行政法规规定或违反了与您的约定，您可联系我们的客服电话或客服邮箱，要求删除该违法行为下收集的您的个人信息。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: black;"
      >（五）如您发现我们收集、储存的您的个人信息有错误的，您可以联系我们的客服电话或者客服邮箱要求更正。</strong>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">六、我们如何处理儿童的个人信息</strong>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: black;"
      >我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，儿童不得创建自己的用户账户。</span>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: black;"
      >对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。</span>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: black;"
      >尽管当地法律和习俗对儿童的定义不同，但我们将不满 14 周岁的任何人均视为儿童。</span>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: black;"
      >如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。</span>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">七、您的个人信息如何在全球范围转移</strong>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: black;"
      >我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。</span>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: black;"
      >如未来为业务发展需要，在获得您的授权同意后，您的个人信息可能会被转移到您使用产品或服务所在国家/地区的境外管辖区，或者受到来自这些管辖区的访问。</span>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: black;"
      >此类管辖区可能设有不同的数据保护法，甚至未设立相关法律。在此类情况下，我们会确保您的个人信息得到在中华人民共和国境内足够同等的保护。例如，我们会请求您对跨境转移个人信息的同意，或者在跨境数据转移之前实施数据去标识化等安全举措。</span>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">八、本政策如何更新</strong>
    </p>
    <p class="ql-align-justify">
      <span style="background-color: transparent; color: black;">我们的隐私政策可能变更。</span>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: black;"
      >未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更。首信易支付鼓励您经常查看本页面，以便了解任何对隐私政策的更改。在本隐私政策进行任何更改之后您继续使用首信易支付服务，则视为您已接受此等更改。</strong>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: black;"
      >对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过电子邮件发送通知，说明隐私政策的具体变更内容）。</span>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">本政策所指的重大变更包括但不限于：</strong>
    </p>
    <p class="ql-align-justify">
      <strong
        style="background-color: transparent; color: black;"
      >1．我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</strong>
    </p>
    <p class="ql-align-justify">
      <strong
        style="background-color: transparent; color: black;"
      >2．我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</strong>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">3．个人信息共享、转让或公开披露的主要对象发生变化；</strong>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">4．您参与个人信息处理方面的权利及其行使方式发生重大变化；</strong>
    </p>
    <p class="ql-align-justify">
      <strong
        style="background-color: transparent; color: black;"
      >5．我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</strong>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">6．个人信息安全影响评估报告表明存在高风险时。</strong>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">我们还会将本政策的旧版本存档，供您查阅。</strong>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">九、如何联系我们</strong>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">如果您对本隐私政策有任何疑问、意见或建议，通过以下方式与我们联系：</strong>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">电子邮件：cs@payeasenet.com</strong>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">电话：010-59321108</strong>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: black;">一般情况下，我们将在三十天内回复。</strong>
    </p>
    <p class="ql-align-justify">
      <strong
        style="background-color: transparent; color: black;"
      >如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以通过向首信易支付住所地人民法院（北京市朝阳区人民法院）提起诉讼的方式寻求解决。</strong>
    </p>
    <p class="ql-align-justify">
      <br />
    </p>
  </div>
</template>

<script>
export default {
  name: "SYSecret",
  created(){
      document.title = "首信易支付隐私政策"
  }
};
</script>

<style>
.agree {
  line-height: 1.5;
  padding:10px;
  font-size: 15px;
}
</style>
